module.exports = __webpack_public_path__ + "static/media/member-placeholder.c8321070.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/member-placeholder.svg
 ** module id = 1282
 ** module chunks = 0
 **/